import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrackerStatusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 39,
	height: 18,
	viewBox: "0 0 39 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2031 16.9999L18.2031 11.249C18.2031 10.6967 17.7554 10.249 17.2031 10.249L3.15152 10.249C2.68928 10.249 2.28727 10.5658 2.17922 11.0153L0.796572 16.7662C0.645365 17.3951 1.12202 17.9999 1.76887 17.9999L17.2031 17.9999C17.7554 17.9999 18.2031 17.5522 18.2031 16.9999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2031 16.9999L18.2031 11.249C18.2031 10.6967 17.7554 10.249 17.2031 10.249L3.15152 10.249C2.68928 10.249 2.28727 10.5658 2.17922 11.0153L0.796572 16.7662C0.645365 17.3951 1.12202 17.9999 1.76887 17.9999L17.2031 17.9999C17.7554 17.9999 18.2031 17.5522 18.2031 16.9999Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7969 16.9999L20.7969 11.249C20.7969 10.6967 21.2446 10.249 21.7969 10.249L35.8485 10.249C36.3107 10.249 36.7127 10.5658 36.8208 11.0153L38.2034 16.7662C38.3546 17.3951 37.878 17.9999 37.2311 17.9999L21.7969 17.9999C21.2446 17.9999 20.7969 17.5522 20.7969 16.9999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7969 16.9999L20.7969 11.249C20.7969 10.6967 21.2446 10.249 21.7969 10.249L35.8485 10.249C36.3107 10.249 36.7127 10.5658 36.8208 11.0153L38.2034 16.7662C38.3546 17.3951 37.878 17.9999 37.2311 17.9999L21.7969 17.9999C21.2446 17.9999 20.7969 17.5522 20.7969 16.9999Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2032 6.75092L18.2032 1C18.2032 0.447715 17.7555 0 17.2032 -1.35515e-10L4.60857 -1.84229e-09C4.13857 -1.90598e-09 3.732 0.327309 3.63164 0.786475L2.37468 6.53739C2.23839 7.16099 2.7133 7.75092 3.35162 7.75092L17.2032 7.75092C17.7555 7.75092 18.2032 7.3032 18.2032 6.75092Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2032 6.75092L18.2032 1C18.2032 0.447715 17.7555 0 17.2032 -1.35515e-10L4.60857 -1.84229e-09C4.13857 -1.90598e-09 3.732 0.327309 3.63164 0.786475L2.37468 6.53739C2.23839 7.16099 2.7133 7.75092 3.35162 7.75092L17.2032 7.75092C17.7555 7.75092 18.2032 7.3032 18.2032 6.75092Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7969 6.75092L20.7969 1C20.7969 0.447715 21.2446 0 21.7969 1.3337e-10L32.9342 1.61875e-09C33.412 1.68248e-09 33.8231 0.338103 33.9154 0.806989L35.0466 6.55791C35.1682 7.17582 34.6952 7.75092 34.0654 7.75092L21.7969 7.75092C21.2446 7.75092 20.7969 7.3032 20.7969 6.75092Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7969 6.75092L20.7969 1C20.7969 0.447715 21.2446 0 21.7969 1.3337e-10L32.9342 1.61875e-09C33.412 1.68248e-09 33.8231 0.338103 33.9154 0.806989L35.0466 6.55791C35.1682 7.17582 34.6952 7.75092 34.0654 7.75092L21.7969 7.75092C21.2446 7.75092 20.7969 7.3032 20.7969 6.75092Z",
			stroke: "currentColor"
		})
	]
});
export default SvgTrackerStatusIcon;
